<template>
  <boxwrap class="events--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search">
        </search>
        <button
          class="btn--create"
          title="create"
          @click="reset(), showModal = true"
        >
          <i class="ico--create"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="checkbox"
              >
                <checkbox>
                  <input type="checkbox" @click="checkAll(events)"/>
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                v-if="checkCol('no', tblSetting)"
                @click="sort('id')"
              >
                no
              </tbl-td>

              <tbl-td
                name="created_at"
                :sort="true"
                v-if="checkCol('created_at', tblSetting)"
                @click="sort('created_at')"
              >
                create at
              </tbl-td>

              <tbl-td
                name="title"
                :sort="true"
                v-if="checkCol('title', tblSetting)"
                @click="sort('title')"
              >
                Title
              </tbl-td>

              <tbl-td
                name="content"
                :sort="true"
                v-if="checkCol('content', tblSetting)"
                @click="sort('content')"
              >
                Content
              </tbl-td>

              <tbl-td
                name="type"
                :sort="true"
                v-if="checkCol('type', tblSetting)"
                @click="sort('type')"
              >
                Type
              </tbl-td>

              <tbl-td
                name="order"
                :sort="true"
                v-if="checkCol('order', tblSetting)"
                @click="sort('order')"
              >
                Order
              </tbl-td>

              <tbl-td
                name="can_comment"
                :sort="true"
                v-if="checkCol('can comment', tblSetting)"
                @click="sort('can_comment')"
              >
                Can Comment
              </tbl-td>

              <tbl-td
                name="hidden"
                :sort="true"
                v-if="checkCol('hidden', tblSetting)"
                @click="sort('is_hidden')"
              >
                hidden
              </tbl-td>

              <tbl-td
                name="image"
                :sort="true"
                v-if="checkCol('image', tblSetting)"
                @click="sort('image')"
              >
                image
              </tbl-td>

              <tbl-td
                name="updated_at"
                :sort="true"
                v-if="checkCol('updated_at', tblSetting)"
                @click="sort('updated_at')"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted_at"
                :sort="true"
                v-if="checkCol('deleted_at', tblSetting)"
                @click="sort('deleted_at')"
              >
                deleted at
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(row, index) in events"
              :key="row.id"
              @click.native="setEdit(row.id)"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="row.id" />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('no', tblSetting)"
              >
                {{ generateNumber(index, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                name="created_at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ row.created_at | date }}
              </tbl-td>

              <tbl-td
                name="title"
                v-if="checkCol('title', tblSetting)"
                :isHtml="true"
                :logs="row.title"
              >
              </tbl-td>

              <tbl-td
                name="content"
                v-if="checkCol('content', tblSetting)"
                :isHtml="true"
                :logs="row.content"
              >
              </tbl-td>

              <tbl-td
                name="type"
                v-if="checkCol('type', tblSetting)"
              >
                {{ row.type }}
              </tbl-td>

              <tbl-td
                name="order"
                v-if="checkCol('order', tblSetting)"
              >
                {{ row.order }}
              </tbl-td>

              <tbl-td
                name="can_comment"
                v-if="checkCol('can comment', tblSetting)"
              >
                {{ row.can_comment }}
              </tbl-td>

              <tbl-td
                name="hidden"
                v-if="checkCol('hidden', tblSetting)"
              >
                {{ row.is_hidden }}
              </tbl-td>

              <tbl-td
                name="image"
                v-if="checkCol('image', tblSetting)"
                @click.native.stop="showImagePopup=true, setEvent(row.id)"
              >
                {{ row.image }}
              </tbl-td>

              <tbl-td
                name="updated_at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ row.updated_at | date }}
              </tbl-td>

              <tbl-td
                name="deleted_at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ row.deleted_at | date }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>

      <div class="accordion-banner">
        <div class="accordion__title">
          <span>
            <i class="ico--layout"></i>
            Layout
          </span>

          <button class="btn--modify">
            <i class="ico--save"></i>
          </button>
        </div>

        <div class="accordion__con">
          <div class="layout">
            <div class="layout__item">
              <div class="layout-head">
                <checkbox>
                  <input
                    name="layout"
                    type="radio"
                  />
                </checkbox>
                <span class="layout-head--label">LAYOUT 1</span>
              </div>
              <div class="layout-body">
                <div class="layout-body__item -banner">
                  <i class="ico--no-image"></i>
                  <div class="layout-banner-dots">
                    <span></span>
                  </div>
                </div>
                <div class="layout-body__item -layout">
                  <div class="layout-col">
                    <div class="layout-col__item -col3">
                      <i class="ico--no-image"></i>
                    </div>
                    <div class="layout-col__item -col3">
                      <i class="ico--no-image"></i>
                    </div>
                    <div class="layout-col__item -col3">
                      <i class="ico--no-image"></i>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="layout__item">
              <div class="layout-head">
                <checkbox>
                  <input
                    name="layout"
                    type="radio"
                    >
                </checkbox>
                <span class="layout-head--label">LAYOUT 2</span>
              </div>
              <div class="layout-body">
                <div class="layout-body">
                  <div class="layout-body__item -banner">
                    <i class="ico--no-image"></i>
                    <div class="layout-banner-dots">
                      <span></span>
                    </div>
                  </div>
                  <div class="layout-body__item -layout">
                    <div class="layout-col">
                      <div class="layout-col__item -col4">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col4">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col4">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col4">
                        <i class="ico--no-image"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="layout__item">
              <div class="layout-head">
                <checkbox>
                  <input
                    name="layout"
                    type="radio"
                    >
                </checkbox>
                <span class="layout-head--label">LAYOUT 3</span>
              </div>
              <div class="layout-body">
                <div class="layout-body">
                  <div class="layout-body__item -banner">
                    <i class="ico--no-image"></i>
                    <div class="layout-banner-dots">
                      <span></span>
                    </div>
                  </div>
                  <div class="layout-body__item -layout">
                    <div class="layout-col">
                      <div class="layout-col__item -col5">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col5">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col5">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col5">
                        <i class="ico--no-image"></i>
                      </div>
                      <div class="layout-col__item -col5">
                        <i class="ico--no-image"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </boxwrap-contents>

    <modal
      class="modal--show-image"
      title=""
      v-if="showImagePopup"
      :activate="showImagePopup"
      @activate="showImagePopup = $event"
    >
      <template slot="body">
        <img :src="`${imgPath}${event.image}`">
      </template>
    </modal>

    <modal
      class="modal--create-event"
      title="create event"
      v-if="showModal"
      :activate="showModal"
      @activate="showModal = $event"
    >
      <template slot="body">
        <div class="events-wrap">
          <div class="events-details -user">
            <div class="events-items -events-as"> <!-- .-events-as -->
              <div class="events-items--lbl">
                <span>Type</span>
              </div>

              <div class="events-items--data">
                <select-list
                  title="type"
                  :withReset="true"
                  v-model="formData.type"
                >
                <!-- v-model="" -->
                  <select-option
                    value="normal"
                    name="normal"
                  >
                    normal
                  </select-option>
                  <select-option
                    value="banner"
                    name="banner"
                  >
                    banner
                  </select-option>
                </select-list>
              </div>
            </div> <!-- .-events-as -->

            <div class="events-items -login-name"> <!-- .-login-name -->
              <div class="events-items--lbl">
                <span>Order</span>
              </div>
              <div class="events-items--data">
                <div class="input-wrap">
                  <input type="text" name="" v-model="formData.order">
                </div>
              </div>
            </div> <!-- .-login-name -->
          </div>

          <div class="events-details">
            <div class="events-items -title">
              <div class="events-items--lbl">
                <span>Title</span>
              </div>

              <div class="events-items--data">
                <div class="textarea-wrap">
                  <quill-editor
                    ref="title"
                    :options="quillTitleConfig"
                    v-model="formData.title"
                  >
                  </quill-editor>
                </div>
<!--                 <div class="input-wrap">
                  <input type="text" v-model="formData.title"/>
                </div> -->
              </div>
            </div>

            <div class="events-items -title">
              <div class="events-items--lbl">
                <span>image</span>
              </div>

              <div class="events-items--data">
                <div class="file-upload-wrap">
	                <label for="event-image" class="file-upload--label">
	                  <i class="ico--upload"></i>
	                  <input
                      ref="image"
                      id="event-image"
                      type="file"
                      class="file-upload--input"
                      @change="attachImage"
										>
	                </label>
	              </div>

              </div>
            </div>
            <div class="events-items">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="formData.content"
                >
                </quill-editor>
              </div>
<!--               <div class="textarea-wrap">
                <text-area v-model="formData.content"></text-area>
              </div> -->
            </div>
            <div class="events-items -buttons">
              <!-- type="toggle"
                toggleA="Enable Comments"
                toggleB="Disable Comments" -->
              <span> comments </span>
              <checkbox>
                <input
                  type="checkbox"
                  v-model="formData.can_comment"
                />
              </checkbox>

              <span> hide </span>
              <checkbox>
                <input
                  type="checkbox"
                  v-model="formData.is_hidden"
                />
              </checkbox>

              <button
                class="btn--create -withlabel"
                @click="submit()"
              >
                <i class="ico--create"></i>
                <span>create</span>
              </button>
            </div>
          </div>

          <div class="events-details"></div>
        </div>
      </template>
    </modal>

    <modal
      class="modal--edit-event"
      title="modfiy event"
      v-if="showEdit"
      :activate="showEdit"
      @activate="showEdit = $event, selected = []"
    >
      <template slot="body">
        <div class="events-wrap">
          <div class="events-details -date">
            <div class="events-items">
              <div class="events-items__date">
                <div class="events-items--lbl">
                  <span>created at</span>
                </div>
                <div class="events-items--data">
                  <div class="input-wrap">
                    <span>{{formData.created_at | date}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="events-items">
              <div class="events-items__date">
                <div class="events-items--lbl">
                  <span>updated at</span>
                </div>
                <div class="events-items--data">
                  <div class="input-wrap">
                    <span>{{formData.updated_at | date}}</span>
                  </div>
                </div>
              </div>
              <div class="events-items__date">
                <div class="events-items--lbl">
                  <span>deleted at</span>
                </div>
                <div class="events-items--data">
                  <div class="input-wrap">
                    <span>{{formData.deleted_at | date}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="events-details -user">
            <div class="events-items -events-as"> <!-- .-events-as -->
              <div class="events-items--lbl">
                <span>Type</span>
              </div>

              <div class="events-items--data">
                <select-list
                  :title="formData.type"
                  :withReset="true"
                  v-model="formData.type"
                >
                <!-- v-model="" -->
                  <select-option
                    value="normal"
                    name="normal"
                  >
                    normal
                  </select-option>
                  <select-option
                    value="banner"
                    name="banner"
                  >
                    banner
                  </select-option>
                </select-list>
              </div>
            </div> <!-- .-events-as -->

            <div class="events-items -login-name"> <!-- .-login-name -->
              <div class="events-items--lbl">
                <span>Order</span>
              </div>
              <div class="events-items--data">
                <div class="input-wrap">
                  <input type="text" name="" v-model="formData.order">
                </div>
              </div>
            </div> <!-- .-login-name -->
          </div>

          <div class="events-details">
            <div class="events-items -title">
              <div class="events-items--lbl">
                <span>Title</span>
              </div>

              <div class="events-items--data">
                <div class="textarea-wrap">
                  <quill-editor
                    ref="content"
                    :options="quillTitleConfig"
                    v-model="formData.title"
                  >
                  </quill-editor>
                </div>
<!--                 <div class="input-wrap">
                  <input type="text" v-model="formData.title"/>
                </div> -->
              </div>
            </div>

            <div class="events-items -title">
              <div class="events-items--lbl">
                <span>image</span>
              </div>

              <div class="events-items--data">
                <div class="file-upload-wrap">
	                <label for="event-edit-image" class="file-upload--label">
	                  <i class="ico--upload"></i>
	                  <input
                      ref="image"
                      id="event-edit-image"
                      type="file"
                      class="file-upload--input"
                      @change="attachImage"
										>
	                </label>
	              </div>

              </div>
            </div>
            <div class="events-items">
              <div class="image-wrap">
                <img id="file-image" src="#" v-if="showImage">
                <img :src="`${imgPath}${formData.image}`" v-if="!showImage">
              </div>
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillContentConfig"
                  v-model="formData.content"
                >
                </quill-editor>
              </div>
<!--               <div class="textarea-wrap">
                <text-area
                  v-model="formData.content"
                  :content="formData.content"
                >
                </text-area>
              </div> -->
            </div>
          </div>

          <div class="events-items -buttons">
            <!-- type="toggle"
              toggleA="Enable Comments"
              toggleB="Disable Comments" -->
            <span> comments </span>
            <checkbox>
              <input
                type="checkbox"
                v-model="formData.can_comment"
              />
            </checkbox>

            <span> hide </span>
            <checkbox>
              <input
                type="checkbox"
                v-model="formData.is_hidden"
              />
            </checkbox>

            <button
              class="btn--modify -withlabel"
              @click="submit()"
            >
              <i class="ico--save"></i>
              <span>modify</span>
            </button>
          </div>
        </div>

          <div class="events-details"></div>
        </div>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Checkbox from '@/components/base/Checkbox'
import Search from '@/components/base/search/Search'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Accordion from '@/components/base/Accordion'
import TextArea from '@/components/base/TextArea'

import CheckDataList from '@/components/base/CheckDataList'
import { quillEditor } from 'vue-quill-editor'

import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    Checkbox,
    Search,
    Pagination,
    Modal,
    Accordion,
    TextArea,
    CheckDataList,
    'quill-editor': quillEditor
  },

  mixins: [ swal, checkAll ],

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 10,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      formData: {
        title: '',
        content: '',
        order: 1,
        type: 'banner',
        image: null,
        can_comment: 0,
        file: null
      },

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      showImagePopup: false,
      showImage: false,
      showEdit: false,
      showLayout: false,
      imgPath: process.env.VUE_APP_STATIC_ASSET_PATH,
      showTblSettings: false,

      selectAll: false,
      selected: [],
      filterBy: [
        {
          value: 'title',
          display: 'title'
        },

        {
          value: 'content',
          display: 'content'
        },

        // {
        //   value: 'login_name',
        //   display: 'name'
        // },

        // {
        //   value: 'login_id',
        //   display: 'uniq id'
        // },

        // {
        //   value: 'created_at',
        //   display: 'date posted'
        // }
      ],
      showModal: false,
      dateBy: [
        {
          value: 'created_at',
          display: 'Posted on'
        }
      ],

      tblSetting: 'events',
      allCols: [
        {
          display: 'no',
          value: 'no'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'title',
          value: 'title'
        },
        {
          display: 'content',
          value: 'content'
        },
        {
          display: 'image',
          value: 'image'
        },
        {
          display: 'type',
          value: 'type'
        },
        {
          display: 'order',
          value: 'order'
        },
        {
          display: 'can comment',
          value: 'can comment'
        },
        {
          display: 'hidden',
          value: 'hidden'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        }
      ],

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  async created () {
    this.search()
  },

  watch: {
    $route ($router) {
      console.log('search')
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search(this.generate($router.query))
    }
  },

  computed: {
    ...mapState('events', ['events', 'event', 'count'])
  },

  methods: {
    ...mapActions('events', [
      'get', 'create', 'update', 'delete', 'getCount', 'setEvent'
    ]),
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ path: '/events', query: this.params })
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({ params: this.params })
      await this.getCount({ params: this.params })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.events.length) {
        this.isEmpty = true
      }
    },

    async visibility (board) {
      this.update({ id: board.id, is_hidden: !board.is_hidden })
    },

    attachImage (e) {
      if (!e.target.files) {
        this.showImage = false
      }

      if (e.target.files && e.target.files.length !== 0) {
        this.showImage = true
        let fileReader = new FileReader()

        fileReader.onload = (event) => {
          this.formData.image = event.target.result
        }

        this.formData.file = e.target.files
        fileReader.readAsDataURL(e.target.files[0])
      }
    },

    async submit () {
      let formData
      let file = this.formData.file
      let clone = Object.assign({}, this.formData)
      let alertTitle = !clone.id ? 'Create Event' : 'Modify Event'
      let success = async () => {
        if (file && file.length !== 0) {
          formData.append('image', file[0])
        }

        if (this.formData.id) {
          formData.append('id', this.formData.id)
        }

        formData.append('title', this.formData.title)
        formData.append('order', this.formData.order)
        formData.append('type', this.formData.type)
        formData.append('content', this.formData.content)
        formData.append('is_hidden', this.formData.is_hidden)
        formData.append('can_comment', this.formData.can_comment)

        this.formData = formData

        if (!clone.id) {
          await this.create(this.formData)
          this.showModal = false
        } else {
          await this.update({ id: clone.id, data: this.formData })
          this.showEdit = false
        }

        this.search()

        this.reset()
      }

      formData = new FormData()

      if (this.formData.title === '' || this.formData.content === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      if (this.formData.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.formData.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, alertTitle)
    },

    setEdit (id) {
      let toEdit = this.events.find((e) => {
        return e.id === id
      })
      toEdit = Object.assign({}, toEdit)

      this.selected.push(id)
      this.formData = toEdit
      this.showEdit = true
    },

    reset () {
      this.formData = {
        title: '',
        content: '',
        order: 1,
        type: 'banner',
        image: null
      }

      this.showImage = false
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    }
  }
}
</script>
